import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryurbaniabusrentalinnashik() {



    const cardData =
    {
        keyword: 'Luxury Urbania Bus Rentals in Nashik',
        heading: 'Urbania on rent in pune: Luxury Urbania Bus Rentals in Nashik',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Luxury Urbania Bus Rentals in Nashik for corporate groups, families, tourists, and event travelers planning comfortable group travel to and from Nashik. Our well-maintained luxury Force Urbania bus fleet provides spacious seating, plush interiors, powerful air-conditioning, and smooth performance, making it ideal for long-distance journeys, airport transfers, corporate outings, weddings, sightseeing tours, and outstation trips between Pune and Nashik. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a refined, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for luxury Urbania bus rentals in Nashik.',

        top: 'Top Places to Visit in Nashik with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga Temple",
    "description": "Trimbakeshwar Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and the most important spiritual site near Nashik. Located at the foothills of the Brahmagiri Mountains, the temple is the origin of the holy River Godavari. Built in black stone with classic Nagara-style architecture, it attracts millions of devotees for rituals like Abhishek, Rudrabhishek, and Pitru Dosha Puja. The temple holds immense religious significance and offers a deeply spiritual and peaceful experience."
  },
  {
    "title": "Ram Kund",
    "description": "Ram Kund is a sacred bathing ghat on the banks of the Godavari River and one of the holiest places in Nashik. According to mythology, Lord Rama bathed here during his exile. Devotees believe that taking a dip in Ram Kund cleanses sins and grants spiritual purification. It is also a major site for performing last rites and rituals, especially during the Kumbh Mela, when millions gather here."
  },
  {
    "title": "Kalaram Temple",
    "description": "Kalaram Temple is an ancient and significant temple dedicated to Lord Rama, built using black stone. The temple is known for its tall shikhara, intricately carved pillars, and peaceful spiritual atmosphere. It also played an important role in India’s social reform movement led by Dr. B.R. Ambedkar. The temple is a major pilgrimage and cultural landmark in Nashik."
  },
  {
    "title": "Sita Gufa",
    "description": "Sita Gufa is a small cave believed to be the place where Goddess Sita stayed during her exile. Located near Panchavati, the cave houses idols of Lord Rama, Sita, and Lakshman. The narrow cave passage and serene surroundings create a deeply devotional experience. It is an essential stop for pilgrims exploring Ramayana-related sites in Nashik."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is one of the most sacred areas in Nashik, associated with the Ramayana era. It is believed that Lord Rama, Sita, and Lakshman spent a significant part of their exile here. The area includes sacred sites like Sita Gufa, Kapaleshwar Temple, and Ram Kund. Panchavati offers a blend of spiritual significance, ancient legends, and a calm riverfront atmosphere."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous wine destination, offering a perfect blend of luxury, nature, and leisure. Visitors can enjoy guided vineyard tours, wine tasting sessions, scenic sunset views, and fine dining experiences. Surrounded by rolling hills and grape plantations, Sula is a must-visit for couples, tourists, and wine enthusiasts looking to experience Nashik’s modern charm."
  },
  {
    "title": "Pandavleni Caves (Trirashmi Caves)",
    "description": "Pandavleni Caves are ancient rock-cut caves dating back over 2,000 years, carved by Jain monks. Located on a hilltop, the caves feature inscriptions, meditation halls, and water tanks. The site also offers panoramic views of Nashik city. It is ideal for history lovers, trekkers, and photography enthusiasts seeking heritage and scenic beauty."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Anjaneri Hills is believed to be the birthplace of Lord Hanuman and is a popular trekking destination near Nashik. The region is rich in mythological importance, lush greenery, waterfalls, and scenic trails. During monsoon, the hills come alive with mist and flowing streams, making it a favorite spot for nature lovers and adventure seekers."
  },
  {
    "title": "Gangapur Dam",
    "description": "Gangapur Dam is a peaceful spot located on the Godavari River, offering scenic views, calm waters, and beautiful sunsets. It is a popular picnic location for families and couples looking for relaxation away from city crowds. The surrounding greenery and cool breeze make it an ideal evening getaway."
  },
  {
    "title": "Muktidham Temple",
    "description": "Muktidham Temple is a white marble temple complex that houses replicas of all 12 Jyotirlingas of India. The temple also features idols of various Hindu deities and inscriptions from the Bhagavad Gita. Its clean surroundings, spiritual ambiance, and architectural beauty make it a must-visit religious attraction in Nashik."
  },
  {
    "title": "Someshwar Waterfall",
    "description": "Someshwar Waterfall is a seasonal waterfall near the Someshwar Temple, especially beautiful during the monsoon. Surrounded by rocky landscapes and flowing streams, it attracts visitors for short trips, photography, and peaceful relaxation. The nearby temple adds religious significance to the natural beauty of the location."
  }
],






"services": [
{
"name": "Luxury Urbania Bus Rentals in Nashik",
"description": "Luxury Urbania Bus Rentals in Nashik offers premium and well-maintained Urbania buses for city and outstation travel. Ideal for families, corporate clients, and tourists, these luxury buses provide plush seating, modern interiors, and professional chauffeur service for a refined travel experience across Nashik."
},
{
"name": "Nashik Luxury Urbania Hire",
"description": "Nashik Luxury Urbania Hire provides high-end Urbania rental services with fully air-conditioned buses for business travel, sightseeing, and group tours. Ensures comfort, safety, and elegance for every journey."
},
{
"name": "Premium Urbania Bus Nashik",
"description": "Premium Urbania Bus Nashik offers upscale buses equipped with luxurious seating and advanced amenities, suitable for corporate travel, family tours, and special occasions."
},
{
"name": "Urbania AC Luxury Bus Nashik",
"description": "Urbania AC Luxury Bus Nashik provides climate-controlled luxury buses designed for smooth and comfortable city travel and long-distance journeys with experienced chauffeurs."
},
{
"name": "Corporate Luxury Urbania Hire Nashik",
"description": "Corporate Luxury Urbania Hire Nashik delivers professional transportation solutions for executives, office events, and corporate outings with punctual service and premium comfort."
},
{
"name": "Luxury Urbania for Outstation Nashik",
"description": "Luxury Urbania for Outstation Nashik offers premium buses for long-distance travel, weekend getaways, and intercity tours, ensuring a relaxed and luxurious journey."
},
{
"name": "Chauffeur Driven Luxury Urbania Nashik",
"description": "Chauffeur Driven Luxury Urbania Nashik ensures stress-free travel with trained and verified drivers, offering safety, comfort, and professionalism throughout the trip."
},
{
"name": "Wedding Luxury Urbania Nashik",
"description": "Wedding Luxury Urbania Nashik provides elegant and spacious luxury buses for wedding guests and family travel, adding comfort and style to special celebrations."
},
{
"name": "Family Tour Luxury Urbania Nashik",
"description": "Family Tour Luxury Urbania Nashik offers comfortable and luxurious buses for family vacations, sightseeing tours, and leisure travel across Nashik and beyond."
},
{
"name": "Best Luxury Urbania Rental Nashik",
"description": "Best Luxury Urbania Rental Nashik offers top-rated luxury Urbania buses with exceptional service, timely pickups, and superior comfort for all travel needs."
},
{
"name": "Executive Urbania Hire Nashik",
"description": "Executive Urbania Hire Nashik provides premium transport solutions for senior executives, business delegations, and VIP travel with luxury interiors and professional drivers."
},
{
"name": "Comfortable Luxury Urbania Nashik",
"description": "Comfortable Luxury Urbania Nashik focuses on smooth rides, spacious seating, and refined interiors, making every journey pleasant and relaxing."
},
{
"name": "High End Urbania Rental Nashik",
"description": "High End Urbania Rental Nashik offers exclusive Urbania buses designed for travelers seeking superior comfort, luxury features, and dependable service."
},
{
"name": "Trusted Luxury Urbania Service Nashik",
"description": "Trusted Luxury Urbania Service Nashik is known for reliability, safety, and premium-quality buses, making it a preferred choice for luxury travel in Nashik."
},
{
"name": "Luxury Tourist Urbania Nashik",
"description": "Luxury Tourist Urbania Nashik provides premium buses for tourists exploring Nashik, offering comfort, elegance, and professional service for memorable travel experiences."
}
],
"tableData": [
["Luxury Urbania Bus Rentals in Nashik", "Nashik Luxury Urbania Hire"],
["Premium Urbania Bus Nashik", "Urbania AC Luxury Bus Nashik"],
["Corporate Luxury Urbania Hire Nashik", "Luxury Urbania for Outstation Nashik"],
["Chauffeur Driven Luxury Urbania Nashik", "Wedding Luxury Urbania Nashik"],
["Family Tour Luxury Urbania Nashik", "Best Luxury Urbania Rental Nashik"],
["Executive Urbania Hire Nashik", "Comfortable Luxury Urbania Nashik"],
["High End Urbania Rental Nashik", "Trusted Luxury Urbania Service Nashik"],
["Luxury Tourist Urbania Nashik", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Luxury Urbania Bus Rentals in Nashik",
        "WhyChoosedescription": "Luxury Urbania Bus Rentals in Nashik are ideal for premium group travel, family outings, corporate events, weddings, vineyard tours, and outstation journeys, offering superior comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Premium and Well-Equipped Luxury Force Urbania Bus",
        "WhyChoosedescription": "Luxury Urbania Bus Rentals in Nashik provide high-end Force Urbania buses with air-conditioning, plush pushback seats, ample legroom, ambient lighting, and premium interiors."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Luxury Urbania Bus Rentals in Nashik come with trained and experienced drivers familiar with Nashik, Mumbai, Pune, Shirdi, and nearby routes, ensuring safe and smooth travel."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Choose Luxury Urbania Bus Rentals in Nashik for fair and transparent pricing with no hidden charges, ensuring value-for-money luxury travel."
    },
    {
        "WhyChooseheading": "24/7 Booking and Dedicated Customer Support",
        "WhyChoosedescription": "Luxury Urbania Bus Rentals in Nashik offer round-the-clock booking assistance and customer support for inquiries, reservations, and urgent travel needs."
    },
    {
        "WhyChooseheading": "Flexible Luxury Rental Packages",
        "WhyChoosedescription": "Luxury Urbania Bus Rentals in Nashik are available for hourly rentals, full-day bookings, multi-day luxury tours, corporate travel, weddings, and customized itineraries."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Premium Maintained Buses",
        "WhyChoosedescription": "All buses under Luxury Urbania Bus Rentals in Nashik are regularly cleaned, sanitized, and meticulously maintained to ensure safety, hygiene, and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Luxury Service",
        "WhyChoosedescription": "Luxury Urbania Bus Rentals in Nashik ensure punctual pickups, professional service, and a seamless luxury travel experience."
    }
]
}

const faqData = [
    {
        question: 'Are Luxury Urbania Bus Rentals in Nashik available for local and outstation travel?',
        answer: 'Yes, Luxury Urbania Bus Rentals in Nashik are available for city travel, vineyard tours, corporate events, weddings, and long-distance journeys.',
    },
    {
        question: 'How can I book Luxury Urbania Bus Rentals in Nashik?',
        answer: 'You can book Luxury Urbania Bus Rentals in Nashik via phone, WhatsApp, or online booking for quick and easy reservations.',
    },
    {
        question: 'Why choose Luxury Urbania Bus Rentals in Nashik?',
        answer: 'Luxury Urbania Bus Rentals in Nashik offer premium interiors, spacious seating, professional drivers, clean buses, and transparent pricing.',
    },
    {
        question: 'Are drivers experienced and professional?',
        answer: 'Yes, all drivers for Luxury Urbania Bus Rentals in Nashik are licensed, well-trained, and experienced in handling luxury Force Urbania buses.',
    },
    {
        question: 'Can pickup and drop-off locations be customized?',
        answer: 'Absolutely. Luxury Urbania Bus Rentals in Nashik allow flexible pickup and drop locations across Nashik and nearby regions.',
    },
    {
        question: 'Are Luxury Urbania Bus Rentals in Nashik available 24x7?',
        answer: 'Yes, Luxury Urbania Bus Rentals in Nashik operate 24x7 for all travel requirements.',
    },
    {
        question: 'Are hygiene and safety standards strictly followed?',
        answer: 'Yes, all luxury buses are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Luxury Urbania Bus Rentals in Nashik accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your luxury travel experience.',
    },
    {
        question: 'Are these buses suitable for corporate, weddings, and premium group travel?',
        answer: 'Yes, Luxury Urbania Bus Rentals in Nashik are perfect for corporate events, weddings, luxury tours, and premium group travel.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Prashant Joshi',
        feedback: 'Luxury Urbania Bus Rentals in Nashik provided an outstanding experience for our corporate event. Premium interiors and excellent service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Kulkarni',
        feedback: 'We booked Luxury Urbania Bus Rentals in Nashik for a wedding function. The bus was luxurious, clean, and very comfortable.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rahul Deshmukh',
        feedback: 'Luxury Urbania Bus Rentals in Nashik made our vineyard tour truly premium and relaxing. Highly recommended.',
        rating: 5,
    },
];





























































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Urbania Bus Rentals in Nashik",
  "image": "https://urbaniaonrentpune.in/assets/images/luxury-urbania-nashik.jpg",
  "description": "Luxury Urbania Bus Rentals in Nashik provide premium AC Urbania buses for corporate travel, weddings, family tours, outstation trips, and executive group travel. Chauffeur-driven luxury Urbania buses offer superior comfort, safety, and a high-end travel experience across Nashik and nearby destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/luxury-urbania-bus-rentals-nashik"
  }
};








    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Luxury Urbania Bus Rentals in Nashik | Premium AC Urbania Hire 
  </title>

  <meta
    name="description"
    content="Book Luxury Urbania Bus Rentals in Nashik for corporate travel, weddings, family tours, executive trips, and outstation journeys. Premium AC Urbania buses with chauffeur-driven service ensure a comfortable, stylish, and high-end travel experience in Nashik."
  />

  <meta
    name="keywords"
    content="Luxury Urbania Bus Rentals in Nashik, Nashik Luxury Urbania Hire, Premium Urbania Bus Nashik, Urbania AC Luxury Bus Nashik, Corporate Luxury Urbania Hire Nashik, Luxury Urbania for Outstation Nashik, Chauffeur Driven Luxury Urbania Nashik, Wedding Luxury Urbania Nashik, Family Tour Luxury Urbania Nashik, Best Luxury Urbania Rental Nashik, Executive Urbania Hire Nashik, Comfortable Luxury Urbania Nashik, High End Urbania Rental Nashik, Trusted Luxury Urbania Service Nashik, Luxury Tourist Urbania Nashik"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/73.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Luxuryurbaniabusrentalinnashik;